import { inject, Injectable } from "@angular/core";
import { MCAuthoritiesEventsAntiquitiesUtils, MCCustomFunctionsParams, MCFieldSchemaService } from "@maslul/common-services";
import { ProductsStoreService } from "../../../store/products";
import { TABS } from "../../../../enum/request/TABS";

@Injectable({
    providedIn: 'root'
})
export class AuthoritiesEventsAntiquitiesUtils extends MCAuthoritiesEventsAntiquitiesUtils {

    private fieldSchemaService = inject(MCFieldSchemaService);
    private productsStore = inject(ProductsStoreService);

    override updatePhoto1Label(_customFunctionsObj: MCCustomFunctionsParams, labelKey: string): void {
        const activeProductGuid = this.productsStore.getSnapshot().activeProduct;

        this.fieldSchemaService.updateFieldSchema('photo1', activeProductGuid, { label: labelKey }, TABS.PRODUCTS);
    }
}
